import { render } from "./ShiftTickets.vue?vue&type=template&id=3d06fdc3&scoped=true&ts=true"
import script from "./ShiftTickets.ts?vue&type=script&lang=ts"
export * from "./ShiftTickets.ts?vue&type=script&lang=ts"

import "./ShiftTickets.vue?vue&type=style&index=0&id=3d06fdc3&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d06fdc3"]])

export default __exports__